"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainMasterPage = void 0;

var React = require("react");

var master_page_1 = require("./master-page");

var names_1 = require("./names");

var maishu_chitu_1 = require("maishu-chitu");

var maishu_toolkit_1 = require("maishu-toolkit");

var MainMasterPage = /*#__PURE__*/function (_master_page_1$Master) {
  _inherits(MainMasterPage, _master_page_1$Master);

  var _super = _createSuper(MainMasterPage);

  function MainMasterPage(props) {
    var _this;

    _classCallCheck(this, MainMasterPage);

    _this = _super.call(this, props);
    _this.name = names_1.masterPageNames.main;
    _this.menuResources = new maishu_chitu_1.ValueStore([]);
    _this.state = {
      menuItems: [],
      username: ""
    };
    _this.app = props.app;

    _this.menuResources.add(function (value) {
      var menuItems = translateToMenuItems(value).filter(function (o) {
        return o.parent == null;
      });

      _this.setState({
        menuItems: menuItems
      });
    });

    return _this;
  }

  _createClass(MainMasterPage, [{
    key: "showPageByNode",
    value: function showPageByNode(node) {
      var children = node.children || [];

      if (!node.page_path && (node.children || []).length > 0) {
        this.showPageByNode(children[0]);
        return;
      }

      var pagePath = node.page_path;

      if (pagePath == null && children.length > 0) {
        node = children[0];
        pagePath = node.page_path;
      }

      if (!pagePath) {
        console.log("MenuItem ".concat(node.name, " page name is empty."));
        return;
      }

      if (pagePath.startsWith("#")) {
        pagePath = pagePath.substr(1); // this.app.redirect(pagePath, { resourceId: node.id });

        location.hash = pagePath;
        return;
      }

      if (pagePath.startsWith("http")) {
        location.href = pagePath;
        return;
      }

      this.app.redirect("outer-page", {
        target: pagePath,
        resourceId: node.id
      });
    }
  }, {
    key: "findMenuItemByResourceId",
    value: function findMenuItemByResourceId(menuItems, resourceId) {
      var stack = new Array();
      stack.push.apply(stack, _toConsumableArray(menuItems));

      while (stack.length > 0) {
        var item = stack.shift();
        if (item == null) return;
        if (item.id == resourceId) return item;
        var children = item.children || [];
        stack.push.apply(stack, _toConsumableArray(children));
      }

      return null;
    }
  }, {
    key: "findMenuItemByPageUrl",
    value: function findMenuItemByPageUrl(menuItems, pageUrl) {
      var stack = new Array();
      stack.push.apply(stack, _toConsumableArray(menuItems));

      while (stack.length > 0) {
        var item = stack.shift();
        if (item == null) throw new Error("item is null");

        if (item.page_path == "#".concat(pageUrl)) {
          // let obj = this.app.parseUrl(item.page_path) || { pageName: '' }
          // if (obj.pageName == pageName)
          return item;
        }

        var children = item.children || [];
        stack.push.apply(stack, _toConsumableArray(children));
      }

      return null;
    }
  }, {
    key: "translateToResource",
    value: function translateToResource(o) {
      var path = o.path; //typeof o.path == "function" ? o.path() : o.path;

      return {
        id: o.id,
        name: o.name,
        page_path: path,
        type: o.hidden ? "module" : "menu",
        icon: o.icon,
        parent_id: o.parentId,
        sort_number: o.sortNumber
      };
    }
  }, {
    key: "setMenu",
    value: function setMenu() {
      var _this2 = this;

      var resources = [];

      for (var _len = arguments.length, menuItems = new Array(_len), _key = 0; _key < _len; _key++) {
        menuItems[_key] = arguments[_key];
      }

      menuItems.sort(function (a, b) {
        return a.sortNumber < b.sortNumber ? -1 : 1;
      });
      var stack = new Array();
      stack.push.apply(stack, menuItems);

      var _loop = function _loop() {
        var item = stack.shift();

        var resource = _this2.translateToResource(item);

        resources.push(resource);
        item.children = item.children || [];
        item.children.forEach(function (c) {
          return c.parentId = resource.id;
        });
        stack.push.apply(stack, _toConsumableArray(item.children || []));
      };

      while (stack.length > 0) {
        _loop();
      }

      this.menuResources.value = resources;
    }
  }, {
    key: "setToolbar",
    value: function setToolbar(value) {
      this.setState({
        toolbar: value
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.app.pageCreated.add(function (sender, page) {
        page.shown.add(function () {
          _this3.setState({
            currentPageUrl: page.url
          });

          _this3.setState({
            resourceId: page.data.resourceId || page.data.resource_id
          });
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var menuData = this.state.menuItems;
      var currentPageUrl = this.state.currentPageUrl || '';
      var firstLevelNodes = menuData.filter(function (o) {
        return o.type == "menu";
      });
      var currentNode;

      if (this.state.resourceId) {
        currentNode = this.findMenuItemByResourceId(firstLevelNodes, this.state.resourceId);
      } else if (currentPageUrl) {
        currentNode = this.findMenuItemByPageUrl(firstLevelNodes, currentPageUrl);
        var q = currentPageUrl.indexOf("?");

        if (currentNode == null && q > 0) {
          var shortUrl = currentPageUrl.substr(0, q);
          currentNode = this.findMenuItemByPageUrl(firstLevelNodes, shortUrl);
        }
      }

      var firstLevelNode = null;
      var secondLevelNode;

      if (currentNode != null) {
        if (currentNode.parent == null) {
          firstLevelNode = currentNode;
        } else if (currentNode.parent.parent == null) {
          //二级菜单
          firstLevelNode = currentNode.parent;
          secondLevelNode = currentNode;
        } else if (currentNode.parent.parent.parent == null) {
          //三级菜单
          firstLevelNode = currentNode.parent.parent;
          secondLevelNode = currentNode.parent;
        }
      }

      var hideFirst = false;
      var hideSecond = false;
      var nodeClassName = '';
      var hideMenuPages = this.state.hideMenuPages || [];

      if (hideMenuPages.indexOf(currentPageUrl) >= 0) {
        nodeClassName = 'hideFirst';
        hideFirst = true;
        hideSecond = true;
      } else if (firstLevelNode == null || (firstLevelNode.children || []).filter(function (o) {
        return o.type == "menu";
      }).length == 0) {
        nodeClassName = 'hideSecond';
        hideSecond = true;
      } // return <div className={`${nodeClassName}`} ref={e => this.element = e || this.element}>
      // </div >


      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: "first",
        style: {
          display: hideFirst ? "none" : ""
        }
      }, React.createElement("ul", {
        className: "list-group"
      }, firstLevelNodes.map(function (o, i) {
        return React.createElement("li", {
          key: i,
          className: o == firstLevelNode ? "list-group-item active" : "list-group-item",
          style: {
            cursor: 'pointer',
            display: o.type != "menu" ? "none" : ''
          },
          onClick: function onClick() {
            return _this4.showPageByNode(o);
          }
        }, React.createElement("i", {
          className: o.icon
        }), React.createElement("span", {
          "menu-id": o.id,
          "sort-number": o.sort_number
        }, o.name));
      }))), React.createElement("div", {
        className: "second",
        style: {
          display: hideSecond ? "none" : ""
        }
      }, React.createElement("ul", {
        className: "list-group"
      }, (firstLevelNode ? firstLevelNode.children || [] : []).filter(function (o) {
        return o.type == "menu";
      }).map(function (o, i) {
        return React.createElement("li", {
          key: i,
          className: o == secondLevelNode ? "list-group-item active" : "list-group-item",
          style: {
            cursor: 'pointer',
            display: o.type != "menu" ? "none" : ''
          },
          "page-url": o.page_path,
          onClick: function onClick() {
            return _this4.showPageByNode(o);
          }
        }, React.createElement("i", {
          className: o.icon
        }), React.createElement("span", {
          "menu-id": o.id,
          "sort-number": o.sort_number
        }, o.name));
      }))), React.createElement("div", {
        className: "main"
      }, React.createElement("nav", {
        className: "navbar navbar-default"
      }, this.state.toolbar), React.createElement("div", {
        className: "page-container page-placeholder",
        ref: function ref(e) {
          return _this4.pageContainer = e || _this4.pageContainer;
        }
      })));
    }
  }, {
    key: "element",
    get: function get() {
      return document.getElementById("main-master");
    }
  }, {
    key: "menuItems",
    get: function get() {
      return this.state.menuItems || [];
    }
  }]);

  return MainMasterPage;
}(master_page_1.MasterPage);

exports.MainMasterPage = MainMasterPage;

function translateToMenuItems(resources) {
  resources.forEach(function (o) {
    o.id = o.id || maishu_toolkit_1.guid();
  });
  var arr = new Array();

  var stack = _toConsumableArray(resources.filter(function (o) {
    return o.parent_id == null;
  }));

  var _loop2 = function _loop2() {
    var item = stack.shift();
    item.children = resources.filter(function (o) {
      return o.parent_id == item.id;
    });

    if (item.parent_id) {
      item.parent = resources.filter(function (o) {
        return o.id == item.parent_id;
      })[0];
    }

    stack.push.apply(stack, _toConsumableArray(item.children));
    arr.push(item);
  };

  while (stack.length > 0) {
    _loop2();
  }

  var ids = arr.map(function (o) {
    return o.id;
  });

  var _loop3 = function _loop3(i) {
    var item = arr.filter(function (o) {
      return o.id == ids[i];
    })[0];
    console.assert(item != null);

    if (item.children.length > 1) {
      item.children.sort(function (a, b) {
        return a.sort_number < b.sort_number ? -1 : 1;
      });
    }
  };

  for (var i = 0; i < ids.length; i++) {
    _loop3(i);
  }

  return arr;
}
